export { FacesRatingBar } from './FacesRatingBar';
